/* Reveal the text fallback if either brand image cannot load. */
(() => {
  const showFallback = (image) => {
    if (!(image instanceof HTMLImageElement) || !image.hasAttribute('data-pf-brand-image')) return;
    const fallback = image.parentElement.querySelector('.pf-brand-fallback');
    if (!fallback) return;
    image.hidden = true;
    fallback.hidden = false;
  };
  document.addEventListener('error', (event) => showFallback(event.target), true);
  document.querySelectorAll('[data-pf-brand-image]').forEach((image) => {
    if (image.complete && image.naturalWidth === 0) showFallback(image);
  });
})();
